import { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import SiteNav from '@/components/SiteNav'
import SiteFooter from '@/components/SiteFooter'
import Home from '@/pages/Home'
import Hybrids from '@/pages/Hybrids'
import BreedingProgram from '@/pages/BreedingProgram'
import About from '@/pages/About'
import Partners from '@/pages/Partners'
import { ScrollTrigger } from '@/lib/anim'

const titles: Record<string, string> = {
  '/': 'Hylix Genetics — Independent non-GMO maize genetics',
  '/hybrids': 'Hybrids — Hylix Genetics',
  '/breeding-program': 'Breeding Program — Hylix Genetics',
  '/about': 'About — Hylix Genetics',
  '/partners': 'Partners — Hylix Genetics',
}

function ScrollManager() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (hash) {
      // Let the target section render before scrolling to it.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' })
        })
      })
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' })
    }
    document.title = titles[pathname] ?? titles['/']
    ScrollTrigger.refresh()
  }, [pathname, hash])
  return null
}

export default function App() {
  return (
    <>
      <ScrollManager />
      <SiteNav />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hybrids" element={<Hybrids />} />
          <Route path="/breeding-program" element={<BreedingProgram />} />
          <Route path="/about" element={<About />} />
          <Route path="/partners" element={<Partners />} />
          {/* Contact lives as the final section of the home page (#contact). */}
          <Route path="/contact" element={<Navigate to="/#contact" replace />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <SiteFooter />
    </>
  )
}
